export const resolveChatOpenReadTarget = (meta) => {
  const unreadCount = Number(meta?.unread_count || 0);
  const lastReadMessageId = Number(meta?.last_read_message_id || 0);
  const lastMessageId = Number(meta?.last_message_id || 0);

  if (!Number.isFinite(unreadCount) || unreadCount <= 0) return 0;
  if (!Number.isFinite(lastMessageId) || lastMessageId <= 0) return 0;
  if (lastMessageId <= lastReadMessageId) return 0;

  return lastMessageId;
};
